<template>
  <div>
    <v-skeleton-loader v-if="$apollo.loading" type="table" />
    <div v-else>
      <template v-if="metricSummaryCoaching">
        <v-row>
          <v-col>
            <v-btn color="primary" @click="downloadRawData">Download Raw Data</v-btn>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left">Coach</th>
                  <th class="text-left">1-on-1</th>
                  <th class="text-left">Grad</th>
                  <th class="text-left">Allocated MTD</th>
                  <th class="text-left">Leaving MTD</th>
                  <!-- <th class="text-left">Allocated Previous Month</th>
                  <th class="text-left">Leaving Previous Month</th> -->
                  <!-- <th class="text-left">Total club clients</th> -->
                  <!-- <th class="text-left">Engagement 1-on-1 %</th>
                  <th class="text-left">Engagement grad %</th> -->
                  <!-- <th class="text-left">Engagement club %</th> -->
                  <!-- <th class="text-left">Brand engagement %</th> -->
                  <th class="text-left">Unresolved chats</th>
                  <th class="text-left">Unresolved tasks</th>
                  <th class="text-left">Comms prev. Day</th>

                  <th class="text-left">Food Log Comments SOW</th>
                  <th class="text-left">Exercise Log Comments SOW</th>
                  <th class="text-left">Social Comments SOW</th>
                  <th class="text-left">Social Likes SOW</th>
                  <th class="text-left">Social Posts SOM</th>
                  <th class="text-left">Calls SOW</th>
                  <th class="text-left">Todos prev. 30 days</th>

                  <th class="text-left">Checkins prev. 30 Days</th>
                  <th class="text-left">Clients No Program</th>
                  <!-- <th class="text-left">Club Clients no program %</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(metric, index) in metricSummaryCoaching" :key="index">
                  <td class="d-flex">
                    <template v-if="metric.id">
                      <v-btn icon :to="`/tasks/${metric.id}`">
                        <v-icon medium color="club" class="mt-2">
                          mdi-cards-club
                        </v-icon>
                      </v-btn>
                      <v-btn icon :to="{ name: 'CoachingOneOnOneSubscription', params: { coachId: metric.id } }">
                        <v-icon medium color="one-on-one" class="mt-2">
                          mdi-numeric-1-box-multiple-outline
                        </v-icon>
                      </v-btn>
                    </template>
                  </td>
                  <td>
                    {{ metric.name }}
                  </td>
                  <td>
                    {{ metric.oneOnOneClientTotal }}
                  </td>
                  <td>
                    {{ metric.gradClientTotal }}
                  </td>
                  <td :class="{ 'metric-green': metric.clientsAllocatedMonthToDate > 0 }">
                    {{ metric.clientsAllocatedMonthToDate }}
                  </td>
                  <td :class="{ 'metric-red': metric.clientsLeavingMonthToDate > 0 }">
                    {{ metric.clientsLeavingMonthToDate }}
                  </td>
                  <!-- <td :class="{ 'metric-green': metric.clientsAllocatedPreviousMonth > 0 }">
                    {{ metric.clientsAllocatedPreviousMonth }}
                  </td>
                  <td :class="{ 'metric-red': metric.clientsLeavingPreviousMonth > 0 }">
                    {{ metric.clientsLeavingPreviousMonth }}
                  </td> -->
                  <!-- <td>
                    {{ metric.clubClientTotal }}
                  </td> -->
                  <!-- <td>
                    <span v-if="metric.oneOnOneClientTotal > 0"
                      >{{ ((metric.oneOnOneEngagedClientTotal / metric.oneOnOneClientTotal) * 100).toFixed(0) }}%
                    </span>
                  </td>
                  <td>
                    <span v-if="metric.gradClientTotal > 0"
                      >{{ ((metric.gradEngagedClientTotal / metric.gradClientTotal) * 100).toFixed(0) }}%
                    </span>
                  </td> -->
                  <!-- <td>
                    <span v-if="metric.clubClientTotal > 0"
                      >{{ ((metric.clubEngagedClientTotal / metric.clubClientTotal) * 100).toFixed(0) }}%</span
                    >
                  </td> -->
                  <!-- <td>
                    <span v-if="brandEngagement(metric)"> {{ brandEngagement(metric) }}% </span>
                  </td> -->
                  <td class="font-weight-bold" :class="unresolvedClass(metric.numberOfUnresolvedChats)">
                    {{ metric.numberOfUnresolvedChats }}
                  </td>
                  <td class="font-weight-bold" :class="unresolvedClass(metric.numberOfUnresolvedTasks)">
                    {{ metric.numberOfUnresolvedTasks }}
                  </td>
                  <td class="font-weight-bold" :class="commsClass(metric)">{{ getCommsPercentage(metric) }}%</td>

                  <td class="font-weight-bold" :class="foodLogClass(metric)">
                    {{ foodLogOutput(metric) }}
                  </td>
                  <td class="font-weight-bold" :class="exerciseLogClass(metric)">
                    {{ exerciseLogOutput(metric) }}
                  </td>
                  <td class="font-weight-bold" :class="commentsClass(metric)">
                    {{ commentsOutput(metric) }}
                  </td>
                  <td class="font-weight-bold" :class="likesClass(metric)">
                    {{ likesOutput(metric) }}
                  </td>
                  <td class="font-weight-bold" :class="postsClass(metric)">
                    {{ postsOutput(metric) }}
                  </td>
                  <td class="font-weight-bold" :class="callsLoggedClass(metric)">
                    {{ callsLoggedOutput(metric) }}
                  </td>

                  <td class="font-weight-bold" :class="todoClass(metric)">
                    {{ todoOutput(metric) }}
                  </td>

                  <td class="font-weight-bold" :class="checkinsClass(metric)">
                    <span v-if="metric.oneOnOneCheckinsForMonth > 0"
                      >{{ ((metric.oneOnOneCheckinsForMonth / metric.oneOnOneClientTotal) * 100).toFixed(0) }}%
                    </span>
                  </td>

                  <td class="font-weight-bold" :class="noProgramsClass(metric)">
                    <span v-if="metric.oneOnOneClientsNoProgram > 0"
                      >{{ ((metric.oneOnOneClientsNoProgram / metric.oneOnOneClientTotal) * 100).toFixed(0) }}%
                    </span>
                    <span v-else>
                      <span v-if="metric.name != 'Coaching'">0%</span>
                    </span>
                  </td>

                  <!-- <td class="font-weight-bold" :class="noProgramsClassClub(metric)">
                    <span v-if="metric.clubClientsNoProgram > 0"
                      >{{ ((metric.clubClientsNoProgram / metric.clubClientTotal) * 100).toFixed(0) }}%
                    </span>
                  </td> -->
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </template>

      <!-- CAREFUL, there is a v-if false here, to hide this. Will remove when we can confirm we don't need it -->
      <v-row v-if="false" align="center" justify="center">
        <v-col cols="12">
          <highcharts v-if="engagementPerCoach" :options="engagementPerCoachReport"></highcharts>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { ENGAGEMENT_PER_COACH_QUERY, COACH_METRIC_SUMAMRY } from "@/graphql/queries/engagement.js";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";
import { DEAL_STATS_QUERY } from "@/graphql/queries/deal";

export default {
  name: "CoachEngagement",
  props: {
    team: {
      type: String,
      required: true,
    },
    metricDate: {
      type: String,
      required: false,
    },
    cohort: {
      type: String,
      required: false,
    },
  },
  mixins: [FileDownloadMixin],
  data() {
    return {
      engagementPerCoach: null,
      metricSummaryCoaching: null,
    };
  },
  methods: {
    foodLogClass(metric) {
      const val = metric.foodLogCommentsStartOfWeek;
      const percentage = (val / (metric.oneOnOneClientTotal + metric.gradClientTotal)) * 100;
      if (percentage > 90) {
        return "metric-green";
      }
      if (percentage > 80) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    foodLogOutput(metric) {
      return metric.foodLogCommentsStartOfWeek;
    },
    exerciseLogClass(metric) {
      const val = metric.exerciseLogCommentsStartOfWeek;
      const percentage = (val / (metric.oneOnOneClientTotal + metric.gradClientTotal)) * 100;
      if (percentage > 90) {
        return "metric-green";
      }
      if (percentage > 80) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    exerciseLogOutput(metric) {
      return metric.exerciseLogCommentsStartOfWeek;
    },
    todoClass(metric) {
      const val = metric.todoPrevious30;
      const percentage = (val / (metric.oneOnOneClientTotal + metric.gradClientTotal)) * 100;
      if (percentage > 40) {
        return "metric-green";
      }
      if (percentage > 20) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    todoOutput(metric) {
      return metric.todoPrevious30;
    },
    likesClass(metric) {
      const val = metric.socialLikesStartOfWeek;
      if (val > 20) {
        return "metric-green";
      }
      if (val > 10) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    likesOutput(metric) {
      return metric.socialLikesStartOfWeek;
    },
    callsLoggedOutput(metric) {
      if (!metric.id) {
        return null;
      }
      const userId = metric.id;
      const user = this.dealStats.callsLogged.find((x) => x.id == userId);
      if (user) {
        return user.total;
      }
      return 0;
    },
    callsLoggedClass(metric) {
      let val = this.callsLoggedOutput(metric);
      let day = this.$moment().day();

      if (!val || val == 0) {
        return "metric-red";
      }
      val = val / day;

      // Expecting 6 a day?
      if (val >= 6) {
        return "metric-green";
      }
      if (val > 2.5) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    postsClass(metric) {
      const val = metric.socialPostsStartOfMonth;
      if (val >= 5) {
        return "metric-green";
      }
      if (val >= 1) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    postsOutput(metric) {
      return metric.socialPostsStartOfMonth;
    },
    commentsClass(metric) {
      const val = metric.socialCommentsStartOfWeek;
      if (val > 90) {
        return "metric-green";
      }
      if (val > 80) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    commentsOutput(metric) {
      return metric.socialCommentsStartOfWeek;
    },

    getCommsPercentage(metric) {
      // we expect 2x comms for each one on one client
      const denominator = metric.oneOnOneClientTotal * 2;
      const number = (metric.commsPreviousDay / denominator) * 100;
      if (number > 0) {
        return number.toFixed(0);
      }
      return 0;
    },
    commsClass(metric) {
      const percentage = this.getCommsPercentage(metric);
      if (percentage > 90) {
        return "metric-green";
      }
      if (percentage > 80) {
        return "metric-yellow";
      }
      return "metric-red";
    },
    unresolvedClass(count) {
      if (count > 15) {
        return "metric-red";
      }
      if (count > 10) {
        return "metric-yellow";
      }
      return "metric-green";
    },
    checkinsClass(metric) {
      const percent = ((metric.oneOnOneCheckinsForMonth / metric.oneOnOneClientTotal) * 100).toFixed(0);
      if (!isNaN(percent)) {
        if (percent >= 70) {
          return "metric-green";
        }
        if (percent >= 60) {
          return "metric-yellow";
        }
        return "metric-red";
      }
      return "";
    },
    noProgramsClass(metric) {
      const percent = ((metric.oneOnOneClientsNoProgram / metric.oneOnOneClientTotal) * 100).toFixed(0);
      if (!isNaN(percent)) {
        if (percent <= 10) {
          return "metric-green";
        }
        if (percent <= 20) {
          return "metric-yellow";
        }
        return "metric-red";
      }
      return "";
    },
    noProgramsClassClub(metric) {
      const percent = ((metric.clubClientsNoProgram / metric.clubClientTotal) * 100).toFixed(0);
      if (!isNaN(percent)) {
        if (percent <= 30) {
          return "metric-green";
        }
        if (percent <= 50) {
          return "metric-yellow";
        }
        return "metric-red";
      }
      return "";
    },
    brandEngagement(metric) {
      const number =
        ((metric.clubEngagedClientTotal + metric.oneOnOneEngagedClientTotal + metric.gradEngagedClientTotal) /
          (metric.clubClientTotal + metric.oneOnOneClientTotal + metric.gradClientTotal)) *
        100;
      if (number > 0) {
        return number.toFixed(0);
      }
    },
    downloadRawData() {
      let csvContent =
        "Label,Total one on one daily clients,Total grad clients,Total club clients,Engagement one on one daily %,Engagement grad %, Engagement club %,Brand engagement %,One on one clients who logged a workout %,Club clients who logged a workout %, Unresolved tasks, Unresolved chats \n" +
        this.metricSummaryCoaching
          .map(
            (metric) =>
              `${metric.name},${metric.oneOnOneClientTotal},${metric.gradClientTotal},${metric.clubClientTotal},${(
                (metric.oneOnOneEngagedClientTotal / metric.oneOnOneClientTotal) *
                100
              ).toFixed(2)},${((metric.gradEngagedClientTotal / metric.gradClientTotal) * 100).toFixed(2)},${(
                (metric.clubEngagedClientTotal / metric.clubClientTotal) *
                100
              ).toFixed(2)},${(
                ((metric.clubEngagedClientTotal + metric.oneOnOneEngagedClientTotal + metric.gradEngagedClientTotal) /
                  (metric.clubClientTotal + metric.oneOnOneClientTotal + metric.gradClientTotal)) *
                100
              ).toFixed(2)},${((metric.oneOnOneUsersThatLoggedWorkout / metric.oneOnOneClientTotal) * 100).toFixed(
                2
              )},${((metric.clubUsersThatLoggedWorkout / metric.clubClientTotal) * 100).toFixed(2)},${
                metric.numberOfUnresolvedChats
              },${metric.numberOfUnresolvedTasks}
            `
          )
          .join("\n");
      this.downloadBase64File("application/csv", btoa(csvContent), `${this.metricDate}_${this.team}_engagement.csv`);
    },
  },

  computed: {
    engagementPerCoachReport() {
      let series = this.engagementPerCoach.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [
            c["actionDate"],
            parseInt((parseInt(c["userCount"]) / parseInt(c["totalUserSample"])) * 100),
          ]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: `${this.team} - Engagement per coach`,
        },
        xAxis: {
          categories: this.engagementPerCoach[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "% engaged",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    engagementPerCoach: {
      query: ENGAGEMENT_PER_COACH_QUERY,
      variables() {
        return {
          team: this.team,
        };
      },
      skip() {
        // CAREFUL, we are skipping this/hiding/removing this. We can delete once we confirm we don't need this anymore.
        return true;
      },
      fetchPolicy: "cache-and-network",
    },
    metricSummaryCoaching: {
      query: COACH_METRIC_SUMAMRY,
      variables() {
        return {
          team: this.team,
          metricDate: this.metricDate,
          cohort: this.cohort,
        };
      },
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.metricDate;
      },
    },
    dealStats: {
      query: DEAL_STATS_QUERY,
      fetchPolicy: "cache-and-network",
      variables: {
        userLimit: 3,
      },
    },
  },
};
</script>
